import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import MainPagetitle from '../../layouts/MainPagetitle';


const AddDocument = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [file, setFile] = useState()
    const [error, setError] = useState([]);

    useEffect(() => {
        if (localStorage.getItem("admintoken")) {

        }
        else {
            navigate('/')
        }
    }, []);

    const onFileChange = (e) => {
        // Check if files are selected and that there's at least one file
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            // Proceed only if the file is of valid type (Blob)
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const blog_image = fileReader.result;
                setFile(blog_image);
            };

            fileReader.onerror = (error) => {
                console.error("FileReader error:", error);
            };

            // Read the file as a data URL
            fileReader.readAsDataURL(file);
        } else {
            // Handle case when no file is selected or file selection was canceled
            console.log("No file selected or file selection canceled.");
            setFile(null); // You can clear the file or handle it based on your needs
        }
    };

    const onSubmitForm = async (event) => {
        event.preventDefault();
        try {
            var userData = {
                "user_id": params.id,
                "document_title": event.target.document_title.value,
                "document_upload": file ? file.split(',')[1] : "",

            }
            console.log(userData)
            let responseData = await PaymentDetailService.documentstore(userData).json()
            if (responseData.status === true) {
                navigate(`/admin/documents/${params.id}`);
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    };

    return (
        <>
            <MainPagetitle mainTitle="Add Document" pageTitle={'Add Document'} parentTitle={'Home'} />
            <div className="container-fluid">
                <form className="form-valide" onSubmit={onSubmitForm}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Add Document</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">

                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >Document Title<span className="text-danger">*</span></label>
                                           

                                            <select className="form-control" name="document_title">
                                                        <option value="Drivers License (Front Side)">Drivers License (Front Side)</option>
                                                        <option value="Drivers License (Back Side)">Drivers License (Back Side)</option>
                                                        <option value="ID (Front Side)">ID (Front Side)</option>
                                                        <option value="ID (Back Side)">ID (Back Side)</option>
                                                    </select>
                                        </div>

                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-number" className="form-label"> Document upload <span className="text-danger">*</span></label>
                                            <img className="img-drop-area" height={file ? 100 : 0} width={file ? 100 : 0} src={file} alt='' />
                                            <input type="file" className="form-control" name='document_upload' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />
                                        </div>



                                    </div>
                                    <div className="text-danger mb-2">{error}</div>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>

        </>
    );
};
export default AddDocument;